export default {
  methods: {
    handleDialogText (target, textKey, pinyinKey) {
      if (pinyinKey === undefined) {
        this.handleVMDialogText(target, textKey)
        return
      }
      if (!target || !target[textKey] || !target[pinyinKey]) {
        return
      }
      if (/[^ ]\n\s*[^\s]/.test(target[textKey])) {
        this.$set(target, textKey, target[textKey].replace(/([^ ])(\n\s*[^\s])/g, '$1 $2'))
      }
      if (/[^ ]\n\s*[^\s]/.test(target[pinyinKey])) {
        this.$set(target, pinyinKey, target[pinyinKey].replace(/([^ ])(\n\s*[^\s])/g, '$1 $2'))
      }
    },
    handleVMDialogText (textKey, pinyinKey) {
      if (!this[textKey] || !this[pinyinKey]) {
        return
      }
      if (/[^ ]\n\s*[^\s]/.test(this[textKey])) {
        this[textKey] = this[textKey].replace(/([^ ])(\n\s*[^\s])/g, '$1 $2')
      }
      if (/[^ ]\n\s*[^\s]/.test(this[pinyinKey])) {
        this[pinyinKey] = this[pinyinKey].replace(/([^ ])(\n\s*[^\s])/g, '$1 $2')
      }
    },
  }
}